import { z } from "zod";

export const schema = z.object({
  products: z
    .array(
      z.object({
        productId: z.string().min(1, "Produto é obrigatório"),
        quantity: z.number().min(1, "Quantidade deve ser maior que zero"),
      })
    )
    .optional(),
  orderDate: z.date(),
  discount: z.number().optional(),
  description: z.string().optional(),
});
